import { inject, observer } from "mobx-react";
// import { TransitionGroup, CSSTransition } from 'react-transition-group'
import cx from "classnames";
import { FC } from "react";
import UserMenu from "./parts/UserMenu";

interface IHeaderProps {
  UIStore?: any;
}

const Header: FC<IHeaderProps> = inject("UIStore")(
  observer((props: IHeaderProps) => {
    const { UIStore } = props;
    const { headerBackgroundColor, enableHeaderShadow } = UIStore;

    return (
      <div className="app-header-left">
        <UserMenu />
      </div>
    );
  })
);

export default Header;
